// @flow
import * as React from 'react';
import { Field } from 'redux-form';

import { FormSelect } from '../../../../components';
import { DRAFT_TURN_LENGTH, league_tooltips } from '../../../../helpers/index';

type Props = {
	league: {
		status: string,
		draft_status: string,
	}
};

export const DraftSettings = ({ league }: Props) => (
	<div>

		<Field
			label='Draft Type'
			name='draft_type'
			options={[
				{
					value: 'live',
					text: 'LIVE',
				},
				{
					value: 'auto',
					text: 'AUTO',
				},
				// {
				// 	value: 'commissioner',
				// 	text: 'COMMISSIONER',
				// },
			]}
			component={FormSelect}
			tooltip={league_tooltips.draft_type}
			is_disabled={league.status !== 'scheduled' || league.draft_status !== 'scheduled'}
		/>

		<Field
			label='Draft Order'
			name='draft_order'
			options={[
				{
					value: 'linear',
					text: 'LINEAR',
				},
				{
					value: 'snake',
					text: 'SNAKE',
				},
			]}
			component={FormSelect}
			tooltip={league_tooltips.draft_order}
			is_disabled={league.status !== 'scheduled' || league.draft_status !== 'scheduled'}
		/>

		<Field
			label='Draft Turn Time'
			name='draft_turn'
			options={DRAFT_TURN_LENGTH}
			component={FormSelect}
			tooltip={league_tooltips.draft_turn}
			is_disabled={league.status !== 'scheduled' || league.draft_status !== 'scheduled'}
		/>
	</div>
);

export default DraftSettings;


// WEBPACK FOOTER //
// ./src/pages/league/leagueSettings/forms/DraftSettings.js